import { render, staticRenderFns } from "./SelectLoginWay.vue?vue&type=template&id=97d241e4&scoped=true&"
import script from "./SelectLoginWay.vue?vue&type=script&lang=js&"
export * from "./SelectLoginWay.vue?vue&type=script&lang=js&"
import style0 from "./SelectLoginWay.vue?vue&type=style&index=0&id=97d241e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d241e4",
  null
  
)

export default component.exports